/**
 * MODULE: platform/browser/frontend/utils/browserPageUrl.ts
 * PURPOSE: Filter placeholder browser URLs from poll updates and URL bar display.
 */

const PLACEHOLDER_URLS = new Set(['about:blank', 'about:srcdoc']);

/** True when the remote page URL is worth showing in the URL bar / poll handler. */
export function isMeaningfulBrowserUrl(url: string | undefined | null): boolean {
  const trimmed = (url ?? '').trim();
  if (!trimmed) return false;
  const lower = trimmed.toLowerCase();
  if (PLACEHOLDER_URLS.has(lower)) return false;
  if (lower.startsWith('chrome://') || lower.startsWith('edge://')) return false;
  return true;
}

/** Normalize user-typed URL bar input for remote navigate/warmup (http/https only). */
export function normalizeBrowserNavigateUrl(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  try {
    const withScheme = /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(trimmed) ? trimmed : `https://${trimmed}`;
    const parsed = new URL(withScheme);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
    return parsed.href;
  } catch {
    return null;
  }
}
